<div class="row ss-top-menu" style="height: unset;">
  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 align-self-center">
    <span class="ss-link ss-text-light" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/wip']">Wip Dashboard </span>
    <span style="vertical-align: -webkit-baseline-middle;"> <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Leads </span>
  </div>
  <div class="rk-ui-notification" style="z-index: 4444 !important" *ngIf="successalert">
    <span id="notificationMessageText">{{ successMessage }}</span>
    <a class="close rk-linknotification" (click)="successalert = false">×</a>
  </div>
  <div class="rk-ui-notification err" style="z-index: 4444 !important" *ngIf="erroralert">
    <span id="notificationMessageText">{{ errorMessage }}</span>
    <a class="close rk-linknotification" (click)="erroralert = false">×</a>
  </div>


  <div  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
    <div *ngIf="role == 'area_sales_manager'">
    <p class="mb-0">Filter By SM </p>
        <ng-select [(ngModel)] = "searchSM"  (change)="filterbyCm($event , 'sm')" style="width: 100%;" class=" "  placeholder="Select Sales Manager" >
          <ng-option selected value="">All</ng-option>
          <ng-option *ngFor="let sales of sm_list" value="{{sales.id}}">{{sales.name}}</ng-option>
        </ng-select>
    </div>
  </div>      

  <div *ngIf="role == 'sales_manager' || role == 'area_sales_manager' || role == 'deputy_general_manager' " class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
      <p class="mb-0">Filter By CM </p>
          <ng-select [(ngModel)] = "searchCM" (change)="filterbyCm($event , 'cm')" style="width: 100%;" class=" "  placeholder="Select Community Manager" >
            <ng-option selected value="">All</ng-option>
            <ng-option *ngFor="let cm of cm_list" value="{{cm.id}}">{{cm.name}}</ng-option>
          </ng-select>
  </div>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4  align-self-end">
    <div class="ss-searchbox">
      <i class="fa fa-search"></i>
      <input class="form-control" type="text" placeholder="Type in name, contact, status, role, Lead Id data to search..." #search (keyup.enter)="onKey($event)">
    </div>
  </div>
  

</div>



<div class="row col-12 body_height justify-content-center">
  <div class="col-12 ">
    <div class="row col-12 justify-content-end">
      <div class="col-md-12 row d-flex align-items-center p-0">
        <div class="col-md-3  align-items-center p-0">
          <span class="text_label mr-2  d-block">Category</span>
         <button  class="p07 w-85 h-45 btn Btn-custom  pl-2 text-left text-capitalize">{{nameOFSelect}} 
          <img *ngIf="nameOFSelect !='Select Category Bucket'" class="pl-2"  src="../../../../assets/X.png" (click)="clearUl()">
          <!-- <i aria-hidden="true" class="fa fa-close color_close fs_10 pl-2" ></i>  -->
          <i class="fa fs_15 pl-2  " [ngClass]="showUl?'fa-angle-up':'fa-angle-down'" aria-hidden="true" (click)="openUl()"></i> </button>
         <ul *ngIf="showUl" class="listStyle p-0">
          <li class="px-2 py-3 border-dash" (click)="Selectparent('')">All</li>
          <li class="px-2 py-3 border-dash"  (click)="Selectparent('ob_bucket')">Order Booking  <i class="fa fs_15  " [ngClass]="categoryFilterBucket  == 'ob_bucket' && condiTA ?'fa-angle-up':'fa-angle-down'" aria-hidden="true"></i>
            <ul *ngIf="ChildUlv=='ob_bucket' && condiTA" class="sublist p-0">
              <li class="px-2 py-2"  [ngClass]="categoryFilter== ''?'activeForUl':''" (click)="Setparam('')">All</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'ob_asta'?'activeForUl':''" (click)="Setparam('ob_asta')">Asta</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'ob_nesta'?'activeForUl':''" (click)="Setparam('ob_nesta')">Nesta</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'ob_solis'?'activeForUl':''" (click)="Setparam('ob_solis')">Solis</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'ob_lux'?'activeForUl':''" (click)="Setparam('ob_lux')">Lux</li>
            </ul>
          </li>
          <li class="px-2 py-3"  (click)="Selectparent('oc_bucket')">Order Confirmation  <i class="fa fs_15  " [ngClass]="categoryFilterBucket == 'oc_bucket' && condiTA?'fa-angle-up':'fa-angle-down'" aria-hidden="true"></i>
            <ul *ngIf="ChildUlv=='oc_bucket' && condiTA"  class="sublist p-0">
              <li class="px-2 py-2"  [ngClass]="categoryFilter== ''?'activeForUl':''" (click)="Setparam('')">All</li>
              <li class="px-2 py-2"  class="px-2 py-2"  [ngClass]="categoryFilter== 'oc_asta'?'activeForUl':''" (click)="Setparam('oc_asta')">Asta</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'oc_nesta'?'activeForUl':''" (click)="Setparam('oc_nesta')">Nesta</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'oc_solis'?'activeForUl':''" (click)="Setparam('oc_solis')">Solis</li>
              <li class="px-2 py-2"  [ngClass]="categoryFilter== 'oc_lux'?'activeForUl':''" (click)="Setparam('oc_lux')">Lux</li>
            </ul>
          </li>
        </ul>
        </div>







       <!-- <div class="col-md-3 d-flex align-items-center p-0 mt-2" [ngClass]="categoryFilterBucket == ' ' ||  categoryFilterBucket == '' ?'disClass':''">
      
        <ng-select *ngIf="categoryFilterBucket == ' ' || categoryFilterBucket == ''" class="form-control select_cats border-0 bg-none" [(ngModel)]="categoryFilter" (clear)="categoryFilter = ''" (change)="searchCategoryProjects()">
          <ng-option value=" " disabled selected>
            Select Category
           </ng-option>
           <ng-option value="" >
          All
           </ng-option>
         <ng-option value="ob_asta">
          Asta
         </ng-option>
         <ng-option value="ob_nesta">
          Nesta
         </ng-option>
         <ng-option value="ob_solis">
          Solis
         </ng-option>
         <ng-option value="ob_lux">
          Lux
         </ng-option>
        </ng-select>
        <ng-select *ngIf="categoryFilterBucket == 'ob_category'" class="form-control select_cats border-0 bg-none" [(ngModel)]="categoryFilter" (clear)="categoryFilter = ''"  (change)="searchCategoryProjects()">
          <ng-option value=" " disabled selected>
            Select Category
           </ng-option>
           <ng-option value="" >
            All
             </ng-option>
         <ng-option value="ob_asta">
          Asta
         </ng-option>
         <ng-option value="ob_nesta">
          Nesta
         </ng-option>
         <ng-option value="ob_solis">
          Solis
         </ng-option>
         <ng-option value="ob_lux">
          Lux
         </ng-option>
        </ng-select>
        <ng-select *ngIf="categoryFilterBucket == 'oc_category'" class="form-control select_cats border-0 bg-none" [(ngModel)]="categoryFilter"  (clear)="categoryFilter = ''" (change)="searchCategoryProjects()">
          <ng-option value=" " disabled selected>
            Select Category
           </ng-option>
           <ng-option value="" >
            All
             </ng-option>
         <ng-option value="oc_asta">
          Asta
         </ng-option>
         <ng-option value="oc_nesta">
          Nesta
         </ng-option>
         <ng-option value="oc_solis">
          Solis
         </ng-option>
         <ng-option value="oc_lux">
          Lux
         </ng-option>
        </ng-select>
       </div> -->

       <div class="col-md-2  align-items-center justify-content-end pr-3 p-0" >
        <span class="text_label mr-2  d-block">Filter By</span>
        <select class="filterSelect form-control Br-sel capitalize h-45" (change)="filterColumDropdownChange($event.target.value)" [(ngModel)]="filtercol1Val" id="filter1dropdown">
          <option value="all" selected><span class="capitalize">All</span></option>
          <option value="list_designer"><span class="capitalize">Designers</span></option>
           <option value="pending"><span class="capitalize"> pending price match request </span></option>
           <!-- <option value="score"><span class="capitalize"> Hot leads</span></option> -->
          <!-- <option value="list_city" *ngIf="lead_status && lead_status != 'leads_not_assigned' && lead_status != 'leads_dropped' "><span class="capitalize">City</span></option> -->
        </select>
       
        

      </div>

      <div  class="col-md-2 d-flex align-items-center justify-content-end p-0" >
        <select  class=" form-control capitalize h-45 Br-sel mt137 h-45 " style="width: 95%!important;" *ngIf="filtercol1Val == 'list_designer'" [(ngModel)]="DesignerID"  (change)="onDesignerFilterSelect($event)">
          <option value="" disabled selected>Select Designer</option>
          <option *ngFor="let design of my_designers" value={{design.id}}>{{ design.name }}</option>
        </select>
      </div>
      
        <div class="filterMainDiv col-md-5  d-flex align-items-center justify-content-end p-0" style="font-size: 15px;">
          
          <span class="addCursor fire_iconstyle  mt-3 px-3 p07" (click)="filterColumDropdownChange('score')">
            <span class="mr-2" style="color: #fff;">Filter By</span>
            <a class="addCursor"><img src="../../../../assets/img/clipart260450.png" class="hot_style"></a>
          </span>
  
            <span class="addCursor  fire_iconstyle p07 px-3 mt-3 mx-2" *ngIf = "showChangeStatus === 'wip' " (click)="buheadApprovalFilter()">
              <span class="mr-2" style="color: #fff;">Cancelled Lead Status</span>
            </span>

            <span class="addCursor fire_iconstyle mt-3 px-3 p07 ml-4" (click)="Clearfilter()">
              <span class="mr-2" style="color: #fff;">Clear</span>
            </span>

          </div>
          

                      
        </div>
      </div>

    

       
       

        <!-- <a class="addCursor" (click)="filterColumDropdownChange('score')"><img src="../../../../assets/img/clipart260450.png" class="hot_style"></a> -->

        <!-- <i class="downArrow fa fa-angle-down d-none" id="downArrow"></i>
        <div id="fromDateFilter" class= "d-none" style="display: inline;">
          <label class="ss-text-dark mr-2">From Date </label>
          <input type="date" name="" [(ngModel)]="from_date" class="form-control filterSelect" style="font-size: 12px;">
        </div>
        <div id="toDateFilter" class= "d-none" style="display: inline;">
          <label class="ss-text-dark mr-2">To Date </label>
          <input type="date" name="" [(ngModel)]="to_date" [min]="from_date" class="form-control filterSelect" style="font-size: 12px;">
        </div> -->
       
      
        </div>
   
  
</div>
<div class="col-12 m-0 p-0 mt-2 ">

  <h5 *ngIf="wipList && wipList.length ==0" class="text-center my-5">No leads Available</h5>
  <div class="tableDiv lappyView">
    <table class="table" *ngIf="wipList && wipList.length >0">
      <thead class="ss-thead">
        <tr>
          <th class="firstTh" style="min-width: 1rem;">#</th>

          <th (click)="sort('name')" class="">
            NAME
            <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'name', 'fa-sort-asc': (column == 'name' && !isDesc), 'fa-sort-desc': (column == 'name' && isDesc) }" aria-hidden="true"></i>
          </th>

          <th (click)="sort('id')">
            LEAD ID
            <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'id', 'fa-sort-asc': (column == 'id' && !isDesc), 'fa-sort-desc': (column == 'id' && isDesc) }" aria-hidden="true"></i>
          </th>

          <th (click)="sort('wip_time')" style="min-width: 12rem;">
            WIP DATE
            <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'wip_time', 'fa-sort-asc': (column == 'wip_time' && !isDesc), 'fa-sort-desc': (column == 'wip_time' && isDesc) }" aria-hidden="true"></i>
          </th>
          <th>
            CURRENT STATUS
          </th>
          <th *ngIf="showChangeStatus!='completed' && !(userRole == 'sales_manager' || userRole == 'area_sales_manager')">CHANGE STATUS</th>
          <th *ngIf="showChangeStatus == 'on_hold'">Last NOC Milestone</th>
          <th>SUBSTATUS</th>
          <th *ngIf = "showChangeStatus === 'wip' " >Cancellation Status</th>
          <th style="min-width: 12rem;">LEAD ACQUIRED</th>
          <th style="min-width: 12rem;">LEAD ASSIGNED (CM)</th>
          <th style="min-width: 12rem;">LEAD ASSIGNED (DESIGNER)</th>
          <th *ngIf="userRole !='community_manager'"  style="min-width: 12rem;"> ASSIGNED CM</th>
          <th style="min-width: 12rem;" (click)="sort('assigned_to')">
            ASSIGNED DESIGNER
            <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'assigned_to', 'fa-sort-asc': (column == 'assigned_to' && !isDesc), 'fa-sort-desc': (column == 'assigned_to' && isDesc) }" aria-hidden="true"></i>
          </th>
          <th></th>
          <ng-container *ngIf =" showChangeStatus != 'inactive'">
            <th></th>
            <th class="lastTh"></th>
          </ng-container>
        </tr>
      </thead>
      <tbody class="ss-tbody">
        <tr *ngFor=" let obj of wipList | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }   |  sort: {property: column, direction: direction}; let i = index" [attr.data-index]="i">
          <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
          <td class="capitalize" style="white-space: nowrap;">
          
            <a class="addCursor ss-link d-block pl-1" routerLink="/lead/{{obj.id}}/overview"  [queryParams]="{customer_status: custom_status}"   *ngIf="obj.project_details;else nolink ">{{obj.name}}   <a data-trigger="hover" [attr.data-content]="'Hot Lead Score:' + obj.score" class="ml-1 cursor-pointer" *ngIf="obj.hot == 'true'" (mouseenter)="openpopup($event)"><img src="../../../../assets/img/clipart260450.png" class="hot_style"></a></a>
            <a *ngIf="obj.lead_ob_category" class="d-inline-block tagStyle " > OB-{{obj.lead_ob_category}}</a><a *ngIf="obj.lead_oc_category" class="d-inline-block ml-1 tagStyle">OC-{{obj.lead_oc_category}}</a>
          
            <a *ngIf ="obj.cancellation_reported && showChangeStatus === 'wip' "><img src="../../../../assets/img/lead-free-cancellation-3190546.png" class="lead_cancel_Style"></a>
            <ng-template #nolink>{{obj.name}} </ng-template>
          </td>
          <td>{{obj.id}}</td>
          <td>{{obj.project_details.wip_time | date:'dd/MM/yyyy - h:mm a'}}</td>
          <td class="capitalize">
            <span *ngIf="obj.project_details">
              <ng-container  *ngIf="(obj.project_details.status!='on_hold' && obj.project_details.status!='inactive')">
                {{ obj.project_details.status | replaceChar }}
              </ng-container>
              <ng-container *ngIf="(obj.project_details.status=='on_hold')">
                  <a data-trigger="hover" title="Remarks/Reason" [attr.data-content] ="obj.project_details.remarks +'  '+'/'+'  '+ (obj.project_details.reason_for_lost === null ? '' : transform(obj.project_details.reason_for_lost))" class="pop" (mouseenter)="openpopup($event)">{{obj.project_details.status | replaceChar}}</a>
                  <p class="time-chng">{{obj.event_scheduled_at.on_hold_time | date:'dd/MM/yyyy - h:mm a'}}</p>
                  <a style="color: #8d0528; cursor: pointer;" (click)="reschedule_onholdevent(obj.project_details.id,obj.next_scheduled_event.id,obj.user_reference.email,obj)">Reschedule</a>
              </ng-container>
              <ng-container *ngIf="(obj.project_details.status=='inactive')">
                  <a data-trigger="hover" title="Remarks" [attr.data-content] ="obj.project_details.sub_cat_reason_lost | replaceChar" class="pop" (mouseenter)="openpopup($event)" *ngIf="obj.project_details.sub_cat_reason_lost!=null && obj.project_details.sub_cat_reason_lost!=''">Cancelled</a>
                <p *ngIf="obj.project_details.sub_cat_reason_lost==null || obj.project_details.sub_cat_reason_lost==''">Cancelled</p>
                <!-- <span *ngIf="obj.project_details.reason_for_lost !=null">Reason:{{obj.project_details.reason_for_lost | replaceChar}}</span> -->
                  <p *ngIf="obj.project_details.reason_for_lost!=null && obj.project_details.reason_for_lost!=''" class="time-chng">(Reason - {{ obj.project_details.reason_for_lost | replaceChar }} )</p>
                  <p *ngIf="obj.project_details.sub_reason_lost!=null && obj.project_details.sub_reason_lost!=''" class="time-chng">
                    (Sub Reason : {{ obj.project_details.sub_reason_lost | replaceChar }})
                  </p>
              </ng-container>
            </span>
          </td>
          <td *ngIf="showChangeStatus!='completed' && !( userRole == 'sales_manager' || userRole == 'area_sales_manager')">
            <select (change) = "onStatusChange(obj.project_details.id,obj.project_details.user_id, $event.target.value,obj)" class="custom-select" *ngIf="obj && obj.project_details">
              <option disabled value="">Change status</option>
              <option value="on_hold" [selected]="obj.project_details.status === 'on_hold'" *ngIf="!['on_hold', 'inactive'].includes(obj.project_details.status)">On Hold</option>
              <option value="inactive" [selected]="obj.project_details.status === 'inactive'" *ngIf="!['on_hold', 'inactive'].includes(obj.project_details.status)">Cancelled</option>
              <option value="active" [selected]="obj.project_details.status === 'active'" *ngIf="['on_hold', 'inactive'].includes(obj.project_details.status)">Active</option>
            </select>

          </td>
            <td *ngIf="showChangeStatus == 'on_hold'" class="capitalize">
             {{obj.before_project_on_hold_status}}
            </td>
          <td>
            <span *ngIf="obj.project_details">{{obj.project_details.sub_status | replaceChar}}</span>
            <!-- <select (change) = "onSubStatusChange(obj.project_details.id,obj.project_details.user_id, $event.target.value)" class="custom-select" *ngIf="obj.project_details && isProjectInWipAndActive(obj.project_details.status)">
              <option>Change sub status</option>
              <option value="meeting_fixed" [selected]="obj.project_details.sub_status === 'meeting_fixed'">Meeting Fixed</option>
              <option value="floorplan_uploaded" [selected]="obj.project_details.sub_status === 'floorplan_uploaded'">Req Sheet and Floor Plan Uploaded</option>
              <option value="initial_proposal_submitted" [selected]="obj.project_details.sub_status === 'initial_proposal_submitted'">Initial Design and BOQ Submitted</option>
              <option value="initial_proposal_accepted" [selected]="obj.project_details.sub_status === 'initial_proposal_accepted'">Initial Design and BOQ Accepted</option>
              <option value="initial_proposal_rejected" [selected]="obj.project_details.sub_status === 'initial_proposal_rejected'">Initial Design and BOQ Rejected</option>
            </select> -->

          </td>

          <td *ngIf ="obj.project_details.status === 'wip'">
            <ng-container *ngIf = "userRole !== 'business_head' && obj.cancellation_reported ">
              <p>Bu Head Action Required</p>
            </ng-container>
            <ng-container *ngIf = "userRole == 'business_head' && obj.cancellation_reported ">
              <button class="cursor-pointer lead-cancell-approve-reject px-2 py-1" (click) = "leadApproveReject( obj.project_details.id, 'accepted' )" >Approve</button>
              <button class="cursor-pointer lead-cancell-approve-reject px-2 py-1" (click) = "leadApproveReject( obj.project_details.id, 'rejected' )">Reject</button>
            </ng-container>
          </td>
          <td>
            <span *ngIf="obj.created_at">{{obj.created_at | date:'dd/MM/yyyy - h:mm a'}}</span>
          </td>
          <td class="capitalize">
            <span *ngIf="obj.status_updated_at">
              {{obj.status_updated_at | date:'dd/MM/yyyy - h:mm a'}}
            </span>
          </td>
          <td class="capitalize">
            <span *ngIf="obj.assigned_at">
              {{obj.assigned_at  | date:'dd/MM/yyyy - h:mm a'}}
            </span>
          </td>
          <td *ngIf="userRole !='community_manager'" >
            {{obj.assigned_cm_name }}  ({{obj.assigned_cm }})
          </td>
          <td>
            {{obj.assigned_to_name}}  ({{obj.assigned_to}})
          </td>
          <td>
              <!-- <img src="assets/img/dashboard/doc.png"> -->
              <i class="fa fa-phone cursor-pointer" (click)="callToLead(obj.contact)" style="    font-size: 1.5rem; color: #8F0020;"></i>
          </td>
          <ng-container *ngIf =" showChangeStatus != 'inactive'" >
          <td>
            <a [href]="obj.customer_portal_link+'&system_user='+current_user_id" class="text-pink" target="_blank">Open Customer Portal</a>
          </td>
          <td>
            <button class="btn btn-pink" (click)="resendMagicLink(obj.project_details.id)">Resend Magic Link</button>
          </td>
        </ng-container>
        </tr>
      </tbody>
    </table>
    <div class="text-center" *ngIf="wipList && wipList.length >0">
      <pagination-controls autoHide="true" (pageChange)="current_page = getWipList($event)"></pagination-controls>
    </div>
  </div>

  <div class="row my-4 mobView">
    <div class="col-12">
      <div *ngIf="wipList && wipList.length >0">
        <div *ngFor=" let obj of wipList | category :search.value | sort: {property: column, direction: direction}; let i = index" [attr.data-index]="i">
          <div class="card card-body mobCard mb-2">
            <a data-toggle="collapse" href="#tableDiv{{i}}">
              <i class="fa fa-angle-right"></i>
            </a>
            <h4 class="ss-link cursor-pointer" routerLink="/lead/{{obj.id}}/overview" *ngIf="obj.project_details;else nolink ">Name: {{obj.name}}</h4>
            <ng-template #nolink>{{obj.name}}</ng-template>
            <div class="row">
              <p class="col-5 mb-0">LEAD ID: {{obj.id}}</p>
              <h6 class="col-7 mb-0 text-center" *ngIf="obj.project_details">
                <span *ngIf="obj.project_details">
                  <ng-container *ngIf="(obj.project_details.status!='on_hold' && obj.project_details.status!='inactive')">
                    {{ obj.project_details.status }}
                  </ng-container>
                  <ng-container *ngIf="(obj.project_details.status=='on_hold')">
                    <a data-trigger="hover" title="Remarks" [attr.data-content]="obj.project_details.remarks" class="pop" (mouseenter)="openpopup($event)">{{obj.project_details.status | replaceChar}}</a>
                    <p class="time-chng">{{obj.event_scheduled_at.on_hold_time | date:'dd/MM/yyyy - h:mm a'}}</p>
                  </ng-container>
                  <ng-container *ngIf="(obj.project_details.status=='inactive')">
                    <a data-trigger="hover" title="Remarks" [attr.data-content]="obj.project_details.remarks" class="pop" (mouseenter)="openpopup($event)">{{obj.project_details.status | replaceChar}}</a>
                  </ng-container>
                </span>
              </h6>
            </div>
          </div>
          <div class="collapse" id="tableDiv{{i}}">
            <div class="card card-body py-0 mb-3">
              <div class="row">
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">WIP DATE</p>
                  <p class="tableInner capitalize">{{obj.project_details.wip_time | date:'dd/MM/yyyy - h:mm a'}}</p>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">CHANGE STATUS</p>
                  <select (change)="onStatusChange(obj.project_details.id,obj.project_details.user_id, $event.target.value,obj)" class="custom-select"
                    *ngIf="obj && obj.project_details">
                    <option>Change status</option>
                    <option value="on_hold" [selected]="obj.project_details.status === 'on_hold'" *ngIf="!['on_hold', 'inactive'].includes(obj.project_details.status)">On Hold</option>
                    <option value="inactive" [selected]="obj.project_details.status === 'inactive'" *ngIf="!['on_hold', 'inactive'].includes(obj.project_details.status)">Inactive</option>
                    <option value="active" [selected]="obj.project_details.status === 'active'" *ngIf="['on_hold', 'inactive'].includes(obj.project_details.status)">Active</option>
                  </select>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">CHANGE SUBSTATUS</p>
                  <select (change)="onSubStatusChange(obj.project_details.id,obj.project_details.user_id, $event.target.value)" class="custom-select"
                    *ngIf="obj.project_details && isProjectInWipAndActive(obj.project_details.status)">
                    <option>Change sub status</option>
                    <option value="meeting_fixed" [selected]="obj.project_details.sub_status === 'meeting_fixed'">Meeting Fixed</option>
                    <option value="floorplan_uploaded" [selected]="obj.project_details.sub_status === 'floorplan_uploaded'">Req Sheet and Floor Plan Uploaded</option>
                    <option value="initial_proposal_submitted" [selected]="obj.project_details.sub_status === 'initial_proposal_submitted'">Initial Design and BOQ Submitted</option>
                    <option value="initial_proposal_accepted" [selected]="obj.project_details.sub_status === 'initial_proposal_accepted'">Initial Design and BOQ Accepted</option>
                    <option value="initial_proposal_rejected" [selected]="obj.project_details.sub_status === 'initial_proposal_rejected'">Initial Design and BOQ Rejected</option>
                  </select>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">LEAD ACQUIRED</p>
                  <p class="tableInner capitalize" *ngIf="obj.created_at">{{obj.created_at | date:'dd/MM/yyyy - h:mm a'}}</p>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">LEAD ASSIGNED (CM)</p>
                  <p class="tableInner capitalize" *ngIf="obj.status_updated_at">{{obj.created_at | date:'dd/MM/yyyy - h:mm a'}}</p>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">LEAD ASSIGNED (DESIGNER)</p>
                  <p class="tableInner capitalize" *ngIf="obj.assigned_at">{{obj.assigned_at | date:'dd/MM/yyyy - h:mm a'}}</p>
                </div>
                <div class="col-12 py-3 borderRight">
                  <p class="tableInner">ASSIGNED DESIGNER</p>
                  <p class="tableInner">{{obj.assigned_to}}</p>
                </div>
                <div class="col-12 callBtn" (click)="callToLead(data.contact)">
                  <span>CALL</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Status modal -->
<div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>On Hold Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="getWipList(1);">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label for="example-text-input" class="col-3 col-form-label">Reopening Date<span class="text-danger">*</span></label>
          <div class="col-9">
            <input type="datetime-local" name="followup-details" id="followup-details" class="form-control" [(ngModel)]="date_reopening" style="width: 70%;" [min]="todayDate">
          </div>
        </div>
        <div class="form-group row">
          <label for="example-text-input" class="col-3 col-form-label">Reason for Hold <span class="text-danger">*</span></label>
         <div class="dropdown" style="width: 70%;">
           <button class="btn btn-secondary dropdown-toggle ml-3" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 70%;"><span *ngIf="!this.dropdownDropType1">Select Reason</span>{{this.dropdownDropType1 | replaceChar}}</button>
           <ul class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
             <li class="dropdown-item"><a (click)="submitDropLeadType1('site_not_ready')">Site Not Ready</a></li>
             <li class="dropdown-item"><a (click)="submitDropLeadType1('possession_delayed')">Possession Delayed</a></li>
             <li class="dropdown-item"><a (click)="submitDropLeadType1('delayed_by_customer')">Delayed By Customer</a></li>
             </ul>
         </div>
       </div>
        <div class="form-group row">
          <label for="example-text-input" class="col-3 col-form-label">Remarks <span class="text-danger">*</span></label>
          <div class="col-9">
            <textarea rows="1" name="followup_remarks" id="followup_remarks" class="form-control" [(ngModel)]="remarks_reopening" style="width: 70%;"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>


      </div>
      <div class="modal-footer">
        <input *ngIf="role !='business_head' && is10percentDone" type="button" [disabled]="!date_reopening || !dropdownDropType1 || !remarks_reopening" id="followup-button"  value="Already Have OTP" class="btn btn-pink" (click)="AlreadyOTP()" >
        <input *ngIf="role =='business_head' || !is10percentDone " type="button" [disabled]="!date_reopening || !dropdownDropType1 || !remarks_reopening" id="followup-button" value="Update" class="btn btn-pink" style="width: 8rem;" (click) = "onCallbackChange()" >
        <input *ngIf="role !='business_head' && is10percentDone" type="button" [disabled]="!date_reopening || !dropdownDropType1 || !remarks_reopening" id="followup-button" value="Send OTP" class="btn btn-green" style="width: 8rem;" (click) = "onCallbackChange()" >
      </div>
    </div>
  </div>
</div>
<div class="modal fade" style="z-index: 88888;" id="OtpModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 30rem;">
    <div class="modal-content">
      <div class="modal-header OtpHeader">
        <h5 class=" text-center"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="relative font-inter antialiased">

          <main class="relative min-h-screen flex flex-col justify-center bg-slate-50 overflow-hidden">
              <div class="w-full max-w-6xl mx-auto px-4 md:px-6 py-24">
                  <div class="flex justify-center">
      
                      <div class="max-w-md mx-auto text-center bg-white px-4 sm:px-8 py-10 rounded-xl shadow">
                          <header class="mb-8">
                              <h1 *ngIf="statusDetails['customer_status'] == 'on_hold'" class="text-2xl fs-25 font-bold mb-2">On Hold OTP Verification</h1>
                              <h1 *ngIf="statusDetails['customer_status'] == 'active'" class="text-2xl fs-25 font-bold mb-2">Un Hold OTP Verification</h1>
                              <h1 *ngIf="statusDetails['customer_status'] == 'extend_on_hold'" class="text-2xl fs-25 font-bold mb-2">Extend On Hold OTP Verification</h1>
                              <p *ngIf="costumerDetails" class="text-[15px] fs-14  text-slate-500">Enter the 6-digit verification code that was sent to the customer's phone number ({{NumerFormat(costumerDetails.contact)}}) and email ({{EmailFormat(costumerDetails.email)}})</p>
                          </header>
                          
                          <div #otpForm class=" w-100 d-flex justify-content-center otp-form">
                            <input class="form-control w-10 text-center py-2" type="text" maxlength="1">
                            <input class="form-control ml-2 w-10 text-center py-2" type="text" maxlength="1">
                            <input class="form-control ml-2 w-10 text-center py-2" type="text" maxlength="1">
                            <input class="form-control ml-2 w-10 text-center py-2" type="text" maxlength="1">
                            <input class="form-control ml-2 w-10 text-center py-2" type="text" maxlength="1">
                            <input class="form-control ml-2 w-10 text-center py-2" type="text" maxlength="1">
                          </div>
                          <div class="w-100 d-flex justify-content-center">
                            <button [disabled]="DisXla().length < 6"  class="btn-pink py-2  w-100 mt-3 br-10 px-4" #submitBtn (click)="Submit()">Verify OTP</button>
                          </div>
                         
                          
                          <div class="text-sm mb-3 text-slate-500 mt-4">Didn't receive code? <a (click)="ShareOtp()" class="font-medium text-primary cursor-pointer text-indigo-500 hover:text-indigo-600" >Resend</a></div>
                      </div>
      
                  </div>
              </div>
          </main>
      
          <!-- Page footer -->
         
      
          <!-- Banner with links -->
          
        


      </div>
      <div class="modal-footer">
     
      </div>
    </div>
  </div>
</div>
</div>
<div class="modal fade" style="z-index: 88888;" id="OtpModalCheck" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 20rem;">
    <div class="modal-content">
      <div class="modal-header OtpHeader">
        <h5 class=" text-center"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ">
        <header class="text-center ">
        <h4>Un Hold OTP Verification</h4>
        </header>
       <div class="w-100 d-flex justify-content-between py-4 " style="padding: 1.5rem 1.25rem 1.5rem 1.25rem;">
        <button class="btn btn-pink" (click)="AlreadyOTP()" > Already Have OTP</button>
        <button class="btn btn-green" (click)="SendOTP()" > Send OTP</button>
       </div>
      <div class="modal-footer">
     
      </div>
    </div>
  </div>
</div>
</div>

<!-- Status modal end -->


<!-- For Inactive Remark -->
<!-- <div class="modal fade" id="statusModal2" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Cancelled Remark Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group row mt-4">
            <input class="form-control" id="inactive_reason" type="hidden" value="{{this.dropdownDropType}}">
            <div class="container">
              <div class="row mb-3">
                 <label for="example-text-input" class="col-3 col-form-label">Reason for Cancelled <span class="text-danger">*</span></label>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span *ngIf="!this.dropdownDropType">Select Reason</span>{{this.dropdownDropType | replaceChar}}</button>
                  <ul class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                    <li class="dropdown-item"><a (click)="submitDropLeadType('out_of_scope')">Out of Scope</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('low_budget')">Low Budget</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('non_serviceable_area')">Non Serviceable Area</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('not_interested')">Not Interested</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('language_barrier')">Language Barrier</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('did_not_like_delivery_timelines')">Did not like Delivery Timelines</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('did_not_like_our_prices')">Did not like Our Prices</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('not_reachable_despite_multiple_attempts')">Not Reachable Despite Multiple Attempts</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('did_not_like_designs')">Did not like Designs</a></li>
                    <li class="dropdown-item"><a (click)="submitDropLeadType('others')">Others</a></li>
                    <li class="dropdown-divider"></li>
                    <li class="dropdown-submenu">
                      <a  class="dropdown-item" tabindex="-1">Already done with Other Vendor</a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-submenu">
                          <a class="dropdown-item" >Organized</a>
                          <ul class="dropdown-menu">
                              <li class="dropdown-item"><a (click)="submitDropLeadType('already_done_with_other_vendor--livspace')">Livspace</a></li>
                              <li class="dropdown-item" (click)="submitDropLeadType('already_done_with_other_vendor--homelane')"><a>Homelane</a></li>
                              <li class="dropdown-item" (click)="submitDropLeadType('already_done_with_other_vendor--design_cafe')"><a>Design Cafe</a></li>
                          </ul>
                        </li>
                        <li class="dropdown-submenu">
                          <a class="dropdown-item">Unorganized</a>
                          <ul class="dropdown-menu">
                              <li class="dropdown-item"><a (click)="submitDropLeadType('already_done_with_other_vendor--local_contractor')">Local Contractor</a></li>
                              <li class="dropdown-item"><a (click)="submitDropLeadType('already_done_with_other_vendor--carpenter')">Carpenter</a></li>
                          </ul>
                        </li>
                         
                      </ul>
                    </li>
                    </ul>
                </div>
              </div>
            </div>
            <label for="example-text-input" class="col-3 col-form-label">Remarks </label>
          <div class="col-9 pr-2" style="margin-left: -10px;">
            <textarea rows="1" name="followup_remarks" id="inactive_remarks" class="form-control"></textarea>
          </div>
        </div>
        <div class="form-group row pull-right mr-2">
          <input type="button" id="followup-button" value="Update" class="btn btn-pink" (click) = "onCallbackChange2()" >
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- end modal -->



<div class="modal fade" id="statusModal2" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
        <div class="modal-header">
          <h5>Cancelled Remark Details </h5>
          <button  type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span (click)="onCancelRemarkModalClose()" aria-hidden="true">&times;</span>
          </button>
        </div>
      <div class="modal-body">
        <form [formGroup]="dropLeadForm">
          <div class="form-group row mt-4">
          
            
            
            <div class="container">
              <div class="row">
                 <label for="example-text-input" class="col-3 col-form-label">Reason for Cancel <span class="text-danger">*</span></label>
                
                <select formControlName="reason_for_drop" (change)="submitDropLeadType2($event.target.value)" >
                  <option value ="" disabled>Select Reason</option>
                  <option value ="low_budget" >Low Budget</option>
                  <option value ="non_serviceable_area" > Non Serviceable or
                    Out of Scope</option>
                  <option value ="timeline" >Timeline</option>
                  <option value ="others" >Other</option>
                </select>
                
              </div>

            </div>
          </div>
          <div class="form-group row">
            <div class="container">
              <div class="row">
                 <label *ngIf="dropLeadForm?.controls['reason_for_drop']?.value != '' " for="example-text-input" class="col-3 col-form-label">Reason<span class="text-danger">*</span></label>
                 <ng-container *ngIf="dropLeadForm?.controls['reason_for_drop']?.value == 'low_budget' ">
                     
                 
                  <select formControlName="reason" (change)="submitDropLeadTypeReason($event.target.value)"  >
                    <option value ="" disabled>Select Reason</option>
                    <option value ="fhi" >FHI</option>
                    <option value ="fhi" > PHI </option>
                   
                  </select>

                     

                </ng-container>
                <ng-container *ngIf="dropLeadForm?.controls['reason_for_drop']?.value == 'non_serviceable_area' ">
                     
                  
                  <select formControlName="reason" (change)="submitDropLeadTypeReason($event.target.value)"  >
                    <option value ="" disabled>Select Reason</option>
                    <option value ="old_furniture_refurbishment" >Old Furniture Refurbishment</option>
                    <option value ="ready_made_furniture" > Ready Made Furniture </option>
                    <option value ="only_on_site-services_execution" > Only on site-services execution </option>
                    <option value ="only_project_designing" > Only Project Designing</option>
                    <option value ="only_project_execution" > Only Project Execution</option>
          
                  </select>
                     

                </ng-container>
                <ng-container *ngIf="dropLeadForm?.controls['reason_for_drop']?.value == 'timeline' ">
                     
                  
                  <select formControlName="reason" (change)="submitDropLeadTypeReason($event.target.value)"  >
                    <option value ="" disabled>Select Reason</option>
                    <option value ="0-30_days" >0 - 30 days</option>
                    <option value ="30-45_days" > 30 - 45 days </option>
                    <option value ="45-60_days" > 45 - 60 days</option>
                    <option value ="60-75_days" > 60 - 75 days</option>
                    <option value ="75-90_days" > 75 - 90 days</option>
          
                  </select>
                     

                </ng-container>
                <ng-container *ngIf="dropLeadForm?.controls['reason_for_drop']?.value == 'others' ">
                     
                  <input class="form-control col-7" id="lost_reason"   formControlName="reason">
                      

                </ng-container>

                
              </div>
            </div>
           
          </div>
          <div class="row">
            <label *ngIf="dropdownDropreason == 'fhi' || dropdownDropreason == 'phi' || dropdownDropreason == 'only_on_site-services_execution' " for="example-text-input" class="col-3 col-form-label">Reason Remark <span class="text-danger">*</span></label>
            <ng-container *ngIf="dropLeadForm?.controls['reason'].value == 'fhi' || dropLeadForm?.controls['reason'].value == 'phi'  ">
             
              <select formControlName="reason_remark" (change)="submitDropLeadTypeSub($event.target.value)"  >
                <option value ="" disabled>Select Reason</option>
                <option value ="1.5 - 3 _lakhs" >1.5 - 3 Lakhs</option>
                <option value ="3 - 5 _lakhs" > 3 - 5 Lakhs</option>
                <option value ="5 - 8 _lakhs" > 5 - 8 Lakhs</option>
                <option value ="8 - 12 _lakhs" > 8 - 12 Lakhs</option>
                <option value ="12 - 16 _lakhs" > 12 - 16 Lakhs</option>
                <option value ="16 - 18 _lakhs" > 16 - 18 Lakhs</option>
                <option value ="18_lakhs_and_above" > 18 Lakhs and above</option>

      
              </select>
                 

            </ng-container>
            <ng-container *ngIf="dropLeadForm?.controls['reason']?.value == 'only_on_site-services_execution' ">
              
              <select formControlName="reason_remark" (change)="submitDropLeadTypeSub($event.target.value)"  >
                <option value ="" disabled>Select Reason</option>
                <option value ="services_up_to_20%" >Services up to 20%</option>
                <option value ="services_up_to_40%" > Services up to 40%</option>
                <option value ="services_up_to_60%" > Services up to 60%</option>
                <option value ="services_up_to_90" > Services up to 90%</option>
      
              </select>
            </ng-container>
           
         </div>
          <div class="form-group row pull-right">
            <!-- <button class="rk-btnCancel addCursor" data-dismiss="modal" (click)="dropleadId=undefined">Cancel</button> -->
            <button class="rk-interalBtnColor mr-3 ml-3 cursor-pointer" [disabled]="!dropLeadForm?.valid" (click)="updateStatus(dropLeadForm.value)">Update</button>
          </div>
         
        </form>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="statusModal3" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Reschedule On Hold Date</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="getWipList(1);">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label for="example-text-input" class="col-3 col-form-label">Reopening Date<span class="text-danger">*</span></label>
          <div class="col-9">
            <input type="datetime-local" class="form-control" id="modal_date" [(ngModel)]="date_details" style="width: 70%;" [min]="todayDate">
          </div>
        </div>
        
        <div class="form-group row">
          <label for="example-text-input" class="col-3 col-form-label">Remarks <span class="text-danger">*</span></label>
          <div class="col-9">
            <input rows="1" type="text" class="form-control" [(ngModel)]="remarks_details" style="width: 70%;" />
          </div>
        </div>


      </div>
      <div class="modal-footer">
        <input *ngIf="role !='business_head' && is10percentDone" type="button" [disabled]="!date_details || !remarks_details" id="followup-button"  value="Already Have OTP" class="btn btn-pink" (click)="AlreadyOTP()" >
        <input *ngIf="role !='business_head' && is10percentDone"  type="button" [disabled]="!date_details || !remarks_details" id="followup-button"  value="Send OTP" class="btn btn-green" (click) = "reschedule_onholdsubmit()" >
        <input *ngIf="role =='business_head' || !is10percentDone "  type="button" [disabled]="!date_details || !remarks_details" id="followup-button"  value="Update" class="btn btn-pink" (click) = "reschedule_onholdsubmit()" >

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-wip/cm-wip.component.html